import { render, staticRenderFns } from "./updateGoods.vue?vue&type=template&id=609aac34&scoped=true"
import script from "./updateGoods.vue?vue&type=script&lang=js"
export * from "./updateGoods.vue?vue&type=script&lang=js"
import style0 from "./updateGoods.vue?vue&type=style&index=0&id=609aac34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609aac34",
  null
  
)

export default component.exports